import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import TracksSlider from './components/TracksSlider';

import CommunityRecommended from './components/CommunityRecommended';
import CommunityNew from './components/CommunityNew';
import MembershipCta from './components/MembserhipCta';

export const COURSES_PAGE_SIZE =
  typeof window !== 'undefined' && window.innerWidth <= 768 ? 8 : 15;

const ContentWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: 1140px) {
    margin: 0;
    width: calc(100% - 264px);
  }
`;

const SlidersGroupWrapper = styled.div`
  & > div:not(:last-child) {
    margin-bottom: 40px;
  }
  @media (min-width: 768px) {
    & > div:not(:last-child) {
      margin-bottom: 40px;
    }
  }
`;

class LandingV2 extends Component {
  shouldComponentUpdate(nextProps) {
    const { courseIdsOwned, packsIdsOwned, loadingCartButton } = this.props;
    const shouldUpdate =
      courseIdsOwned.length !== nextProps.courseIdsOwned.length ||
      packsIdsOwned.length !== nextProps.packsIdsOwned.length ||
      loadingCartButton !== nextProps.loadingCartButton;

    return shouldUpdate;
  }

  render() {
    const {
      courseIdsOwned,
      packsIdsOwned,
      removeCourseFromCart,
      addCourseToCart,
      removePackFromCart,
      tracks,
      user,
      isOrganization,
      loadingCartButton,
      countryPrefix,
      userLanguage,
      t,
    } = this.props;

    return (
      <ContentWrapper>
        <SlidersGroupWrapper>
          <CommunityRecommended
            courseIdsOwned={courseIdsOwned}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
            size={COURSES_PAGE_SIZE}
            user={user}
            isUserLogged={!!user}
            isOrganization={isOrganization}
            loadingCartButton={loadingCartButton}
            userLanguage={userLanguage}
          />
          <CommunityNew
            courseIdsOwned={courseIdsOwned}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
            size={COURSES_PAGE_SIZE}
            user={user}
            isUserLogged={!!user}
            loadingCartButton={loadingCartButton}
            isOrganization={isOrganization}
            userLanguage={userLanguage}
          />
          {!(user && user.isPremiumMember) && (
            <MembershipCta countryPrefix={countryPrefix} />
          )}
          <TracksSlider
            tracks={tracks}
            title={t('COURSE_CAREERS_TITLE')}
            linkText={t('COURSE_CAREERS_WATCH_MORE')}
          />
        </SlidersGroupWrapper>
      </ContentWrapper>
    );
  }
}

LandingV2.propTypes = {
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  packsIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  removePackFromCart: PropTypes.func.isRequired,
  countryPrefix: PropTypes.string,
  userLanguage: PropTypes.string.isRequired,
  user: PropTypes.shape({}),
  isOrganization: PropTypes.bool,
  loadingCartButton: PropTypes.bool.isRequired,
};

LandingV2.defaultProps = {
  countryPrefix: '',
  user: null,
  tracks: [],
  isOrganization: false,
};

const mapStateToProps = state => ({
  tracks: state.tracks,
  userLanguage: state.userLanguage,
});

export default connect(mapStateToProps)(
  withTranslation(CATALOG_TRANSLATION_KEY)(LandingV2),
);
